import { PrinterOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons'
import { Tag, Form as AntForm, Select, Menu, Dropdown } from 'antd'
import axios from 'axios'
import { Button, DeleteButton, Form, Modal, Table, TableCard, Input, Drawer, Export, Map } from 'components'
import React, { useEffect, useState } from 'react'
import { FaPen, FaPlus, FaDownload, FaFilter, FaCaretRight } from 'react-icons/fa6'
import { MdDelete, MdEdit } from "react-icons/md";
import { FiMoreHorizontal} from "react-icons/fi";
import { Link } from 'react-router-dom'
import searchFields from './searchFields';
import dayjs from 'dayjs'
import { CgScrollH } from 'react-icons/cg'
import ExcelRender from 'modules/components/ExcelRender'
import { Option } from "antd/es/mentions";

const type = [
    {label:'Агуулах', value: 'Агуулах'},
    {label:'Дэлгүүр', value: 'Дэлгүүр'}, 
  ]
  const staticData = [47.91795272, 106.92232505]

function Warehouse() {
  const [ data, setData ] = useState([])
  const [ editData, setEditData ] = useState(null)
  const [ loading, setLoading ] = useState(false)
  const [ actionLoading, setActionLoading ] = useState(false)
  const [ showModal, setShowModal ] = useState(false)
  const [ filterOpen, setFilterOpen ] = useState(false);
  const [ currentPage, setCurrentPage ] = useState(0)
  const [ header, setHeader ] = useState([]);
  const [ cols, setCols ] = useState([]);
  const [ openModalFileEdit, setOpenModalFileEdit ] = useState(false);
  const [ form ] = Form.useForm()
  const [ location, setLocation] = useState([]);
  const [ filterForm ] = Form.useForm();
  const [ district, setDistrict] = useState([]);
  const [ province, setProvince ] = useState([]);
  const [ selectedProvince, setSelectedProvince] = useState(null);


  const status = [
    {label: <Tag color='error'>Дууссан</Tag>, value: 0},
    {label: <Tag color='processing'>Хэвийн</Tag>, value: 1}, 
    {label: <Tag color='success'>Сунгасан</Tag>, value: 2}, 
  ]

  useEffect(() => {
    getData()
    getProvince();
  },[])

  // useEffect(() => {
    // form.setFieldsValue({
      // map: location,
      // provinceid: data?.provinceid,
      // districtid: data?.districtid,
    // });

  // },[form, data])


  const getData = () => {
    setLoading(true)
    axios({
      method: 'get',
      url:'warehouses'
    }).then((res) => {
        let tmp = [];
        res.data.map((item) => tmp.push({ ...item, end_date: dayjs(item.end_date)}))
        setData(tmp)
        setLocation([res.data.lat, res.data.lng]);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  }
  const getProvince = () => {
    axios({
      method: 'get',
      url: 'provinces',
    }).then((res) => {
      let tmp = res.data.map((item) => ({
        value: parseInt(item.id),
        label: item.name,
    }));
      setProvince(tmp);
      const prov = tmp.find((prov) => prov.value == data?.provinceid)
    }).catch((err) => {})
  };

  const getDistrict = () => {
    if (selectedProvince) {
      axios({
            method: 'get',
            url: `/districts?provinceid=${selectedProvince}`,
        })
        .then((res) => {
            let tmp = res.data.map((item) => ({
              value: parseInt(item.id),
              label: item.name,
            }));
            setDistrict(tmp);
        })
        .catch(() => {});
    }
  }; 
   useEffect(() => {
      getDistrict();
  }, [ selectedProvince]);
  
  const handleProvinceChange = (value) => {
    setSelectedProvince(value);
  };
  
  const columns = [
    {
      title: '№',
      dataIndex: 'No',
      key: 'No',
      width: 50,
      align: 'center',
      cellRender: (e) => (
        <span>{e.rowIndex + currentPage+1}</span>
      )
    },
    {
      title: 'Нэр',
      dataIndex: 'name',
      key: 'name',
      cellRender: ({value, data}) => (
        <Link to={`/warehouse/${data?.id}`}><div className="flex flex-row">
         <div className="action-cell flex items-center gap-2"><FaCaretRight />
        </div>{value}
        </div></Link>
      )
    },
    {
      title: 'Төрөл',
      dataIndex: 'type',
      key: 'type',
      // cellRender: ({value, data}) => (
        //   <>{type.find((item) => item?.value === value)?.label}</>
        // )
      }, 
    {
      title: 'Байрлал',
      dataIndex: 'location',
      key: 'location',
    },   
    {
      title: 'Хот/Аймаг',
      dataIndex: 'province.name',
      key: 'location',
    },   
    {
      title: 'Дүүрэг',
      dataIndex: 'district.name',
      key: 'location',
    },   
    {
      title: 'Тайлбар',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 90,
      cellRender: ({ value, data }) => {
        // Dropdown menu items
        const menu = (
          <Menu>
            <Menu.Item key="1" icon={<MdEdit />} onClick={() => handleEditButton(data)}>
              Edit
            </Menu.Item>
            <Menu.Item key="2" icon={<MdDelete/>} danger onClick={() => handleDelete(data)}>
              Delete
            </Menu.Item>
          </Menu>
        );
  
        return (
          <div className="action-cell flex items-center gap-2 " >
            <Dropdown overlay={menu} trigger={['click']}>
              <Button
                type="ghost"
                size="sm"
                icon={<FiMoreHorizontal style={{fontSize : '8px', width: "16px"}}/>}
              />
            </Dropdown>
          </div>
        );
      },
    }
  ]

  const fields = [
    {
      label: 'Нэр',
      name: 'name',
      rules: [{required: true, message: 'Нэр оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
    {
      label: 'Төрөл',
      name: 'type',
      type: 'select',
      rules: [{required: true, message: 'Төрөл оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
        options: type

      }
    },
      // {
      //   label: 'Аймаг',
      //   name: 'provinceid',
      //   type: 'select',
      //   rules: [{required: true, message: 'Аймаг оруулна уу'}],
      //   className: 'col-span-6 mb-1',
      //   inputProps: {
      //     options: province

      //   }
      // },
      // {
      //   label: 'Дүүрэг',
      //   name: 'districtid',
      //   type: 'select',
      //   rules: [{required: true, message: 'Дүүрэг оруулна уу'}],
      //   className: 'col-span-6 mb-1',
      //   inputProps: {
      //     options: district
      //   }
      // },
      { 
      type:'component',
      component:(
        <Form.Item
        label="Аймаг"
        name="provinceid"
        rules={[{ required: true, message: 'Аймаг оруулна уу' }]}
        className="col-span-6 mr-2"
    >
        <Select
            placeholder="Аймаг оруулна уу"
            onChange={handleProvinceChange}
            value={selectedProvince}
            >
            {province.map((opt) => (
                <Option key={opt.value} value={opt.value} label={opt.label}
                >
                    {opt.label}
                </Option>
                  ))}
        </Select>
    </Form.Item>

      )
    },
    { 
      type:'component',
      component:(
        <Form.Item
        label="Дүүрэг"
        name="districtid"
        rules={[{ required: true, message: 'Дүүрэг оруулна уу' }]}
        className="col-span-6 mb-1"
      >
        <Select placeholder="Дүүрэг сонгох">
          {district.map((dist) => (
            <Option key={dist.value} value={dist.value} label={dist.label}>
              {dist.label}
            </Option>
          ))}
        </Select>
      </Form.Item>

      )
    },
   
    {
      label: 'Байрлал',
      name: 'location',
      rules: [{required: true, message: 'Байрлал оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
    {
        label: 'Тайлбар',
        name: 'description',
        type: 'textarea',
        // rules: [{required: true, message: 'Тайлбар оруулна уу'}],
        className: 'col-span-12 mb-1',
        inputProps: {
        }
      },
      {
        type: 'component',
        rules: [
          { required: true, message: 'Байршил гараар зааж оруулна уу' }
        ],
        component: (
          <Form.Item name="map" className="col-span-12" rules={[{ required: true, message: 'Байршил оруулна уу' }]}>
            <Map className="h-[230px]" onChange={() => {}} disabled={false} />
          </Form.Item>
        )
      }
      
  ]
  const handleSubmit = (values) => {
    const { map, ...restValues } = values; 
    setActionLoading(true);
    if (editData) {
        axios({
            method: 'put',
            url: `/warehouse`,
            data: {
                ...restValues, 
                id: editData.id,
                lat: map[0], 
                lng: map[1] 
            }
        }).then((res) => {
            getData();
            handleCancel();
        })
            .catch((err) => {})
            .finally(() => {
                setActionLoading(false);
            });
    } else {
        axios({
            method: 'post',
            url: `/warehouse`,
            data: {
                ...restValues, 
                lat: map[0], 
                lng: map[1] 
            },
        })
            .then((res) => {
                getData();
                handleCancel();
            })
            .catch((error) => {
                console.error('Error:', error);
            }).catch((err) => {})
            .finally(() => {
                setActionLoading(false);
            });
    }
}



  const handleAddButton = (data) => {
    setEditData(null)
    setShowModal(true)
  }

  const handleEditButton = (data) => {
    setEditData(data)
    setShowModal(true)
    setSelectedProvince(data?.provinceid)
    form.setFieldsValue({ map: [data.lat, data.lng] });

  }
  const handleDelete = (data) => {
    setActionLoading(true)
    axios({
      method: 'delete',
      url: `/warehouse/${data.id}`,
    }).then((res) => {
      getData()
      handleCancel()
    }).catch((err) => {
    })
    .finally(() => {
      setActionLoading(false)
    })
  }
  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleCancel = () => {
    setShowModal(false)
    if(editData){
      setEditData(null)
    }else{
      form.resetFields()
    }
  }

  const handleFilterSubmit = (values) => {
    setLoading(true);
    axios({
      method: 'get',
      url: `/warehouse_search`,
      params: values
    }).then((res) => {
      setData(res.data);
      setFilterOpen(false);
    }).catch((err) => {
    }).finally(() => setLoading(false))
  };
  
  const handleOpenFile = () => {
    setOpenModalFileEdit(true);
  };

  const handleCloseFileModal = () => {
    setOpenModalFileEdit(false);
  };
  const handleOpenModalFileEdit = () => {
    setOpenModalFileEdit(true);
  };

  const handleOpenCloseModalFileEdit = () => {
    setOpenModalFileEdit(false);
  };

  const handleFileSubmit = (values, method) => {
    let tmp = [];
    cols.forEach((item, i) => {
        if (i !== 0) {
            let nameIndex = header.indexOf('name'); 
            let name = item[nameIndex];
            tmp.push({
                name: name,
            });
        }
    });
    if(method ===  'post'){
      if(data?.type === 0){
        setLoading(true);
        axios({
          method: 'post',
          url: '/brand',
         
            data: tmp,
          
        }).then(() => {
          getData();
          handleCloseFileModal();
        }).catch((err) => {
        }).then(() => setLoading(false))
      } 
      else {
        setLoading(true)
        axios({
          method: 'post',
          url: '/brand',
        
            data: tmp,
        
        }).then(() => {
          getData();
          handleCloseFileModal();
        }).catch((err) => {
        }).then(() => setLoading(false))
      }
    }
    else {
      if(data?.type === 0){
        setLoading(true);
        axios({
          method: 'put',
          url: '/brand',
        
            data: tmp,
       
        }).then(() => {
          getData();
          handleOpenCloseModalFileEdit();
        }).catch((err) => {
        }).then(() => setLoading(false))
      }
      else {
        setLoading(true)
        axios({
          method: 'put',
          url: '/brand',
            data: tmp,
       
        
        }).then(() => {
          getData();
          handleOpenCloseModalFileEdit();
        }).catch((err) => {
          
          
        }).then(() => setLoading(false))
      }
    };
  };
  return (
    <TableCard
      header={
        <div className='flex flex-col'>
          <div className='w-full flex justify-between items-center gap-4'>
          <h1 className='text-2xl font-medium'>Агуулахын жагсаалт</h1>
            <div className='flex items-center gap-2'>
            <Button icon={<FaFilter/>} onClick={() => setFilterOpen(true)}>Шүүлтүүр</Button>
              <Export
                fileData={data} 
                fileName={'Агуулах'} 
              />
              {/* <Button
                icon={<PrinterOutlined className=''/>}
                onClick={handleOpenFile}
              >Excel оруулах</Button> */}
              <Button type='primary' icon={<FaPlus/>}  onClick={handleAddButton}>Нэмэх</Button>
            </div>          
          </div>
        </div>
      }
    >
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
      />
      <Modal title={editData ? 'Засах' : 'Шинээр нэмэх'}    open={showModal} onCancel={handleCloseModal}>
        <Form
        
          form={form}
          fields={fields}
          editData={editData}
          onFinish={handleSubmit}
          className={'gap-2'}
        >
          <div className='col-span-12 flex justify-end items-center gap-2 mt-5'>
            <Button type='primary' onClick={() => form.submit()} loading={actionLoading} icon={<SaveOutlined/>}>Хадгалах</Button>
            <Button onClick={handleCancel} disabled={actionLoading}>Цуцлах</Button>
          </div>
        </Form>
      </Modal>
      <Drawer
        open={filterOpen}
        onClose={() => setFilterOpen(false)} 
      >
        <div>
          <h1 className='text-xl text-black-text font-bold'>Шүүх</h1>
          <Form
              form={filterForm}
              fields={searchFields()}
              onFinish={handleFilterSubmit}
              className='gap-4'
            />  
            <Button className='w-full mt-4' size='sm' type="primary" onClick={() => filterForm.submit()}>Хайх</Button>
        </div>
      </Drawer>
      <Modal
          title={<div className="text-lg uppercase">{'Агуулах excel оруулах'}</div>}
          open={openModalFileEdit}
          onCancel={handleOpenCloseModalFileEdit}
          width={1200}
          destroyOnClose
          footer={false}
        >
          <AntForm
            form={form}
            onFinish={(values) => handleFileSubmit(values, 'post')} 
          >
            <AntForm.Item>
              <ExcelRender header={header} setHeader={setHeader} cols={cols} setCols={setCols} />
            </AntForm.Item>
            <AntForm.Item>
              <div className="flex justify-end">
                <Button
                  type="primary"
                  onClick={() => form.submit()}
                  loading={actionLoading}
                  icon={<SaveOutlined />}
                >
                  Хадгалах
                </Button>
              </div>
            </AntForm.Item>
          </AntForm>
        </Modal>
    </TableCard>
  )
}

export default Warehouse;